import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Col, Row, Tree } from 'antd';
import { omit, uniqBy } from 'lodash-es';
import { createUseStyles } from 'react-jss';
import { FreeTable } from '../FreeTable';
import { BaseModal } from './BaseModal';
const useStyles = createUseStyles({
    freeModal: {
        '& .ant-modal-content .ant-modal-body': {
            overflow: 'auto',
        },
        '& .ant-pro-table-list-toolbar-container': {
            '& .ant-pro-table-list-toolbar-left': {
                gap: '0 !important',
                width: '40%',
            },
            '& .ant-space-item:nth-child(2)': {
                width: '100%',
            },
        },
        '& .ant-modal-content .ant-modal-body .ant-pro-table .ant-input-group-wrapper': {
            width: '100% !important',
            minWidth: '150px',
        },
        '& .ant-modal-content .ant-modal-body .ant-pro-table .ant-pro-card-body': {
            padding: ({ treeProps }) => treeProps ? '0 24px 0 0' : 'auto',
        },
        '& .ant-modal-content .ant-tree .ant-tree-treenode': {
            width: '100% !important',
        },
        '& .ant-modal-content .ant-tree .ant-tree-node-content-wrapper': {
            width: '100% !important',
        },
    },
});
export const FreeModal = (props) => {
    const { tableProps, treeProps, onOk, selectType = 'radio', ...modalProps } = props;
    const { rowName = 'name', rowKey = 'id', pagination, rowSelection, options, columns, ..._tableProps } = tableProps;
    const isRadio = selectType === 'radio';
    const [selectRows, setSelectRows] = useState([]);
    const selectedRowKeys = rowSelection?.selectedRowKeys;
    const onchange = rowSelection?.onChange ?? null;
    const styles = useStyles({ treeProps });
    useEffect(() => {
        if (selectedRowKeys) {
            setSelectRows(selectedRowKeys);
        }
    }, [selectedRowKeys]);
    return (_jsx(BaseModal, { footerLeft: _jsx(_Fragment, { children: selectRows?.length > 0 && (_jsxs(_Fragment, { children: [_jsx("span", { children: "\u5DF2\u9009\uFF1A" }), isRadio ? (_jsx("a", { style: { cursor: 'default' }, title: selectRows[0][rowName], children: selectRows[0][rowName] })) : (_jsxs("a", { style: { cursor: 'default' }, children: [selectRows.length, "\u9879"] }))] })) }), onOk: () => {
            onOk?.(selectRows);
        }, className: styles.freeModal, ...modalProps, children: _jsxs(Row, { children: [treeProps ? (_jsxs(Col, { span: 6, style: { maxHeight: 650, overflow: 'auto' }, children: [_jsx(ModalTree, { treeProps: treeProps }), ' '] })) : null, tableProps ? (_jsx(Col, { span: treeProps ? 18 : 24, style: {
                        paddingLeft: treeProps ? 24 : 0
                    }, children: _jsx(ModalTable, { pagination: pagination, rowKey: rowKey, selectType: selectType, onchange: onchange, selectRows: selectRows, setSelectRows: setSelectRows, _rowSelection: omit(rowSelection, 'selectedRowKeys'), options: options, tableProps: _tableProps, columns: columns }, rowKey?.toString() ?? 'id') })) : null] }) }));
};
const ModalTable = ({ pagination, rowKey, selectType, selectRows, setSelectRows, _rowSelection, options, tableProps, onchange, columns, }) => {
    const _columns = columns?.map((column) => ({ ellipsis: true, ...column }));
    const { scroll, onRow, cardProps, ...rest } = tableProps;
    return (_jsx(FreeTable
    // style={{
    //   maxHeight: 500,
    //   overflow: 'auto',
    //   width: '100%',
    // }}
    , { 
        // style={{
        //   maxHeight: 500,
        //   overflow: 'auto',
        //   width: '100%',
        // }}
        scroll: {
            y: 500,
            ...(scroll ?? {}),
        }, pagination: pagination === false
            ? false
            : {
                defaultPageSize: 5,
                pageSizeOptions: ['5', '10', '15', '20'],
                ...pagination,
            }, columns: _columns, serial: false, rowKey: rowKey, rowSelection: {
            type: selectType,
            preserveSelectedRowKeys: true,
            selectedRowKeys: selectRows?.map((item) => item?.[rowKey]),
            onChange: (rowKeys, rows) => {
                // 处理选择不同分页时的数据丢失
                const totalSelectRows = uniqBy([
                    ...selectRows,
                    ...(rows || [])
                ], rowKey);
                const newSelectRows = totalSelectRows.filter(filterItem => filterItem && rowKeys?.includes(filterItem[rowKey]));
                setSelectRows(newSelectRows);
                if (onchange) {
                    onchange(rowKeys, newSelectRows);
                }
            },
            ..._rowSelection,
        }, 
        // 点击行
        onRow: (record) => {
            return {
                onClick: () => {
                    // 判断是不是只读数据
                    if (_rowSelection?.getCheckboxProps?.(record)?.disabled === true) {
                        return;
                    }
                    let newRows = [];
                    if (selectRows && selectType !== 'radio') {
                        const index = selectRows?.findIndex((item) => item[rowKey] === record[rowKey]);
                        newRows = selectRows
                            ? JSON.parse(JSON.stringify(selectRows))
                            : [];
                        if (index === -1) {
                            newRows.push(record);
                        }
                        else {
                            newRows.splice(index, 1);
                        }
                    }
                    else {
                        newRows = [record];
                    }
                    setSelectRows(newRows);
                    if (onchange) {
                        onchange(newRows.map((item) => item[rowKey]), newRows);
                    }
                },
                ...onRow,
            };
        }, search: false, tableAlertRender: false, options: {
            search: { name: 'name' },
            density: false,
            fullScreen: false,
            reload: false,
            setting: false,
            ...options,
        }, cardProps: {
            ...cardProps,
            bodyStyle: {
                padding: 0,
                ...(cardProps?.bodyStyle ?? {})
            }
        }, ...rest }));
};
const ModalTree = ({ treeProps }) => {
    return (_jsx("div", { style: {
            borderRight: '1px solid #F0F2F5',
            height: '100%',
        }, children: _jsx(Tree, { style: {
                padding: '0 16px 16px 16px',
            }, ...treeProps }) }));
};
